import { TKey } from "@/app/translations/TKey";

export enum HomePricingPeriod {
  MONTHLY = "monthly",
  ANNUAL = "annual",
}

export type HomePricingPeriodTab = {
  period: HomePricingPeriod;
  labelKey: TKey;
};
